/*
 * @Description:
 * @Author: lijinpeng
 * @Date: 2024-05-14 17:12:26
 * @LastEditTime: 2024-07-12 09:48:23
 * @LastEditors: lijinpeng
 */
import variables from '@/styles/element-variables.scss';
import defaultSettings from '@/settings';
import { getNotifyAnnouncement } from '@/api/notify';

const { showSettings, tagsView, fixedHeader, sidebarLogo, menuOpen } = defaultSettings;

const state = {
  theme: variables.theme,
  showSettings: showSettings,
  tagsView: tagsView,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  menuOpen: menuOpen,
  headerHeight: 0, // 头部固定区域高度
  showNoticeBar: false, // 是否展示通知栏
  noticeContent: [], // 通知栏列表
};

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  },
  SET_HEADER_HEIGHT: (state, height) => {
    state.headerHeight = height;
  },
  SET_SHOW_NOTICE_BAR: (state, show) => {
    state.showNoticeBar = show;
  },
  SET_NOTICE_CONTENT: (state, show) => {
    state.noticeContent = show;
  },
};

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data);
  },
  setHeaderHeight: ({ commit, state }) => {
    let height = 52;
    if (state.tagsView) height += 35;
    if (state.showNoticeBar) height += 38;
    commit('SET_HEADER_HEIGHT', height);
  },
  getNotify({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      // 获取公告
      getNotifyAnnouncement()
        .then(res => {
          const { code, data } = res;
          if (code === 200 && data) {
            commit('SET_SHOW_NOTICE_BAR', data.publishStatus === 1);
            commit('SET_NOTICE_CONTENT', data.content);
            dispatch('setHeaderHeight');
            resolve();
          } else {
            reject();
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
